import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';


export default function WebsiteHostingSupport() {
  return (
      <>
    <SEO title="Website Domain and Hosting Support" />
    <div className="max-w-6xl mx-auto px-4 py-10 space-y-16">
      {/* Page Title */}
      <section className="text-center">
        <h1 className="text-4xl font-bold text-[#ff9b00] mb-4">
          Website Hosting & Support
        </h1>
        <p className="text-lg text-gray-700 max-w-3xl mx-auto">
          Reliable hosting, expert technical support, and smooth domain management—all in one place. We ensure your website is fast, secure, and always online.
        </p>
      </section>

      {/* Why Hosting Matters */}
      <section className="grid md:grid-cols-2 gap-10 items-center">
        <div>
          <h2 className="text-2xl font-semibold text-[#ff9b00] mb-4">
            Why Professional Hosting & Support?
          </h2>
          <ul className="list-disc list-inside text-gray-700 space-y-3">
            <li>Ensure 99.9% website uptime with secure and fast servers</li>
            <li>Get assistance with domain registration and renewals</li>
            <li>Daily backups and 24/7 monitoring for peace of mind</li>
            <li>Expert support team to resolve any issue promptly</li>
            <li>Free SSL certificates for secure browsing</li>
          </ul>
        </div>
        <img
          src="/assets/hosting-support.svg"
          alt="Hosting Illustration"
          className="w-full max-w-md mx-auto"
        />
      </section>

      {/* Our Hosting Features */}
      <section>
        <h2 className="text-2xl font-semibold text-[#ff9b00] text-center mb-8">
          Our Hosting & Support Features
        </h2>
        <div className="grid md:grid-cols-3 gap-6">
          <FeatureCard
            title="Domain Management"
            desc="We handle domain registration, DNS configuration, renewals, and transfers."
          />
          <FeatureCard
            title="Scalable Hosting"
            desc="Choose shared, VPS, or cloud hosting solutions tailored to your needs."
          />
          <FeatureCard
            title="24/7 Technical Support"
            desc="Our team is available around the clock to assist with any issue or question."
          />
          <FeatureCard
            title="Security & Backups"
            desc="Daily backups, DDoS protection, SSL, and malware scans keep your site secure."
          />
          <FeatureCard
            title="Performance Monitoring"
            desc="We ensure your website loads fast and stays online with real-time monitoring."
          />
          <FeatureCard
            title="Email & Storage Setup"
            desc="Professional email setup (e.g., info@yourdomain.com) with hosting storage options."
          />
        </div>
      </section>

      {/* Our Process */}
      <section>
        <h2 className="text-2xl font-semibold text-[#ff9b00] text-center mb-8">
          Our Hosting & Support Process
        </h2>
        <div className="grid md:grid-cols-4 gap-6 text-center">
          {[
            'Initial Consultation & Needs Assessment',
            'Domain Purchase & Hosting Setup',
            'Website Migration or Deployment',
            'Ongoing Monitoring & Support',
          ].map((step, index) => (
            <div
              key={index}
              className="p-5 border rounded-lg shadow-sm bg-white hover:shadow-md transition"
            >
              <span className="text-3xl font-bold text-[#ff9b00]">{index + 1}</span>
              <p className="mt-2 text-gray-700">{step}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Call to Action */}
      <section className="text-center bg-[#ff9b00] text-white py-10 rounded-xl shadow-md">
        <h3 className="text-2xl font-bold mb-3">
          Need Hassle-Free Hosting and Support?
        </h3>
        <p className="mb-5">
          Let us manage your website's performance, uptime, and security—so you can focus on your business.
        </p>
        <Link
          to="/contact-us"
          className="inline-block bg-white text-[#ff9b00] px-6 py-2 rounded-full font-medium hover:bg-orange-100 transition"
        >
          Contact Us Now
        </Link>
      </section>
    </div>
    </>
  );
}

function FeatureCard({ title, desc }) {
  return (
    <div className="p-5 border rounded-xl bg-white shadow-sm hover:shadow-md transition">
      <h3 className="text-xl font-semibold text-[#0a3c6d] mb-2">{title}</h3>
      <p className="text-gray-600">{desc}</p>
    </div>
  );
}
